import React, {Component} from "react";
import "./AddDeviceModal.scss";
import GridDuck from 'gridduck';
import GdModal from "../../components/GdModal/GdModal";
import {
    CardBody,
    GdAutocomplete
} from "gd-react";
import {toTitleCase} from '../../services/stringFormatter'
import OptionCard from "../../components/OptionCard/OptionCard";
import AddPhysicalDevice from "./AddPhysicalDevice";
import AddVirtualDevice from "./AddVirtualDevice";

class AddManualDeviceModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            footer: [],
            deviceType: null,
            wide: false,
            site: null
        };
        ['closeModal', 'selectSite', 'getSiteShortcuts', 'getSites', 'updateFooter', 'backToTypeSelection', 'setWide'].forEach(func => this[func] = this[func].bind(this));
    }

    closeModal() {
        this.modalClosed = true;
        this.props.onClose();
    }

    setWide(wide) {
        this.setState({wide: wide});
    }

    updateFooter(footerElements) {
        this.setState({footer: footerElements});
    }

    backToTypeSelection() {
        this.setState({deviceType: null, footer: []});
    }

    async selectSite(site, siteObj) {

        if (siteObj) {
            let item = {
                itemType: 'site',
                itemId: siteObj?.id
            };
            await GridDuck.createSearchHistory(item)
        }

        this.setState({
            site: siteObj,
            loaded: true
        });
    }

    async getSiteShortcuts() {
        let filters = [
            {
                field: 'itemType',
                value: 'site'
            }
        ]

        let res = await GridDuck.getSearchHistorys({filters: filters})
        let shortcuts = res.list.map((r) => {
            return {
                id: r.itemId,
                title: r.name,
                subtitle: r.metadata.locationName,
                locationId: r.metadata.locationId,
                icon: 'GiAnticlockwiseRotation',
                type: 'Recent'
            }
        })
        this.setState({siteShortcuts: shortcuts});
    }

    async getSites(searchTerm, reset) {

        let self = this
        if (reset) this.siteOffset = 0
        let filters = []
        let limit = 25
        if (searchTerm) filters.push({
            field: 'search',
            value: searchTerm
        })
        let sitesRes = await GridDuck.getSites({filters: filters, offset: this.siteOffset})
        let sites = sitesRes.list
            .filter(s => s._permission === 'admin')
            .map((s) => {
                return {
                    id: s.id,
                    title: s.name,
                    locationId: s.locationId,
                    subtitle: s.locationName ? s.locationName : '',
                    icon: 'FaBuilding',
                }
            })
        //updating offset to begin 'get' after latest result
        let newOffset = self.siteOffset + limit;
        self.siteOffset = newOffset
        return Promise.resolve(sites)
    }

    render() {
        return <GdModal
            wide={this.state.wide}
            open={this.props.open}
            contentLabel={'Add Device'}
            title={`Add ${toTitleCase(this.state.deviceType)} Device`}
            isMobile={this.props.isMobile}
            footer={this.state.footer.length ? this.state.footer : null}
            onClose={this.closeModal}>
            <CardBody additionalclasses={'no-padding rule full-height'}>
                {/* 1. Select site*/}
                {!this.state.deviceType && <div>
                    <div className={'form-container'}>
                        <div className={'row'}>
                            <GdAutocomplete
                                async
                                icon
                                subtitle
                                lazyload
                                autoFocus={!this.state.site}
                                getShortcuts={this.getSiteShortcuts}
                                shortcuts={this.state.siteShortcuts}
                                getList={this.getSites}
                                name={'site'}
                                getOptionSelected={function (option, value) {
                                    if (option && value) return option.id === value.id;
                                }}
                                value={this.state.site}
                                placeholder={'Select a site'}
                                onChange={this.selectSite}
                                label="Site"/>
                        </div>
                    </div>
                    {this.state.site && <div>
                        {/* 2. Select device type (Virtual or Physical)*/}
                        <div className={'form-container no-top'}>
                            <div className={'modal-question-container'}>
                                <p className={'question'}>I'm adding a...</p>
                            </div>
                            <OptionCard selected={this.state.deviceType === 'physical'}
                                        onClick={() => this.setState({deviceType: 'physical'})}
                                        type={'physical_device'}/>
                            <OptionCard selected={this.state.deviceType === 'virtual'}
                                        onClick={() => this.setState({deviceType: 'virtual'})}
                                        type={'virtual_device'}/>
                        </div>
                    </div>}
                </div>}
                {/* 3. Continued logic exists within the type component*/}
                {this.state.deviceType === 'physical' && <AddPhysicalDevice setWide={this.setWide} siteId={this.state.site?.id} closeModal={this.closeModal} backToTypeSelection={this.backToTypeSelection} updateFooter={this.updateFooter}/>}
                {this.state.deviceType === 'virtual' && <AddVirtualDevice setWide={this.setWide} siteId={this.state.site?.id} closeModal={this.closeModal} backToTypeSelection={this.backToTypeSelection} updateFooter={this.updateFooter}/>}
            </CardBody>
        </GdModal>
    }
}

export default AddManualDeviceModal;